<template>
    <div v-show="isContractAuth">
        <div class="content" v-if="bShowContent" :style="{'padding-bottom':isShowShare?'100px':'0'}">
            <div class="content_bg"></div>
            <div class="report_warp">
                <div class="report_tips report_tips_fin" v-if="objReport.fin_status != 1">
                    <div>尊敬的{{objReport.name || ''}}：</div>
                    <div class="tips_text" v-html="objReport.head_tips"></div>
                </div>
                <div :class="{'people-fin':objReport.fin_status != 1}" class="people">
                    <!-- 监理 -->
                    <template  v-for="(item, index) in objReport.responsible">
                        <div class="people_one">
                            <div class="people_one_left">
                                <div class="header_img">
                                    <img v-lazy="item.icon" alt="">
                                </div>
                                <div class="header_info">
                                    <div>监理</div>
                                    <div class="info_name">{{ item.name }}</div>
                                    <div class="work_card">工牌：{{ item.job_number }}</div>
                                </div>
                            </div>
                            <div class="people_one_right" v-if="item.qr_code" @click="setQrcode(item)">
                                <img src="@/assets/images/member/process/code_icon.png" alt="">
                            </div>
                        </div>
                    </template>
                    <template v-if="!objReport.responsible.length && false">
                        <div class="people_one">
                            <div class="people_one_left">
                                <div class="header_img">
                                    <img src="@/assets/images/archives/zhipai_icon.png" alt="">
                                </div>
                                <div class="header_info">
                                    <div>监理</div>
                                    <div class="info_name_dai" :style="{'--color':'#3D3C4F','--size':'28px'}">待指派</div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="people_two">
                        <!-- 项目经理 -->
                        <template v-if="objReport.title != '采暖隐蔽系统施工监理报告'">
                            <template v-for="(item, index) in objReport.project_manager" >
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img v-lazy="item.icon" alt="">
                                        </div>
                                        <div class="header_info">
                                            <div>{{ item.rel_group_name }}</div>
                                            <div class="info_name">{{ item.name }}</div>
                                            <div class="work_card">工牌：{{ item.job_number }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="!objReport.project_manager.length">
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img src="@/assets/images/archives/zhipai_icon.png" alt=""></img>
                                        </div>
                                        <div class="header_info">
                                            <div>项目经理</div>
                                            <div class="info_name_dai" :style="{'--color':'#999999'}">待指派</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <!-- 施工人员 -->
                        <template v-if="!objReport.bPerson">
                            <template v-for="(item, index) in objReport.service_person">
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img v-lazy="item.icon" alt="">
                                        </div>
                                        <div class="header_info">
                                            <div>{{ item.rel_group_name }}</div>
                                            <div class="info_name">{{ item.name }}</div>
                                            <div class="work_card">工牌：{{ item.job_number }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="!objReport.service_person.length">
                                <div class="people_warp_item">
                                    <div class="people_one_left">
                                        <div class="header_img">
                                            <img src="@/assets/images/archives/zhipai_icon.png" alt=""></img>
                                        </div>
                                        <div class="header_info">
                                            <div>施工员</div>
                                            <div class="info_name_dai" :style="{'--color':'#999999'}">待指派</div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <!-- 验收合格图标 -->
                    <div class="fin_status" :class="{'fin_status-null':!objReport.responsible.length}" v-if="objReport.fin_status == 1">
                        <img src="@/assets/images/member/process/hege_icon.png" alt="">
                    </div>
                </div>

                <div class="report_item"
                    v-for="(item, index) in objReport.process" :key="index">
                    <div class="report_item_title">
                        <span class="span_title">
                            {{ item.title }}
                        </span>
                        <span class="span_test">
                            {{ item.quality_point_title }}
<!--                            <i :class="item.bCateOpen ? '' : 'open_test'"></i>-->
                        </span>
                    </div>
                    <div class="report_item_warp">
                        <div class="report_item_warp_text" v-if="item.tips">
                            {{ item.tips }}
                        </div>
                        <div
                            :class="['report_item_nav', item.tag_list.constructor == Object ? 'item_nav_center' : '']">
                            <div :class="['nav_item', item.nCateTag == sumitem.tag_id ? 'atv_nav_item' : '']"
                                v-for="(sumitem, sumindex) in item.tag_list" :key="sumindex"
                                @click.stop="cliclTag(item, sumitem)">
                                {{ sumitem.tag_name }}
                            </div>
                        </div>
                        <div class="swiper_img"
                            v-if="item.photo_list.constructor == Object && item.photo_list[item.nCateTag] && item.photo_list[item.nCateTag].length">
                            <van-swipe :show-indicators="false" :ref="'vanSwiper' + index" :loop="true" @change="swipetwo($event, item)">
                                <van-swipe-item v-for="(attitem, attindex) in item.photo_list[item.nCateTag]"
                                    :key="attindex">
                                    <div class="swipe_img_url" @click="getShow(item.photo_list[item.nCateTag],attindex,index)">
                                        <img v-lazy="attitem" alt="">
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                            <div class="img_tips">{{item.photo_text}}</div>
                            <div class="swiper_point">
                                <div :class="[item.nCateTagSwiper == poinindex ? 'color_point' : '']"
                                    v-for="(poinitem, poinindex) in item.photo_list[item.nCateTag]" :key="poinindex">
                                </div>
                            </div>
                        </div>
                        <div class="swiper_list_sm"
                            v-if="item.photo_list.constructor == Object && item.photo_list[item.nCateTag] && item.photo_list[item.nCateTag].length">
                            <div class="swiper_list_scroll">
                                <div :class="['swiper_list_item', item.nCateTagSwiper == attindex ? 'click_item' : '']"
                                    v-for="(attitem, attindex) in item.photo_list[item.nCateTag]" :key="attindex"
                                    @click="getShow(item.photo_list[item.nCateTag],attindex,index)">
                                    <img v-lazy="attitem" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="line" v-if="item.acceptance_line&&item.acceptance_line[item.nCateTag].length"></div>
                        <div class="tabble" v-if="item.acceptance_line&&item.acceptance_line[item.nCateTag].length">
                            <div class="tabble_h">
                                <div class="tabble_h_one">验收质控点</div>
                                <div class="tabble_h_two">施工标准</div>
                                <div class="tabble_h_three">验收结果</div>
                            </div>
                            <template v-if="item.acceptance_line">
                                <template v-for="(attitem, attindex) in item.acceptance_line[item.nCateTag]">
                                    <div class="tabble_d" v-if="item.bCateOpen?true:attindex<3">
                                        <div class="tabble_display">
                                            <div class="tabble_d_one" :class="{'tabble_d_one_active':attitem.is_right==1}">
                                            <span v-html="attitem.title">
                                            </span>
                                            </div>
                                            <div class="tabble_d_two">
                                                <span>{{ attitem.standard_answer }}</span>
                                            </div>
                                            <div class="tabble_d_three">
                                                <span>{{ attitem.answer_result }}</span>
                                            </div>
                                        </div>
                                        <div class="help_tips" v-if="attitem.selling_points != ''">
                                            {{ attitem.selling_points }}
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                        <div class="open_close" v-if="item.acceptance_line.length&&item.acceptance_line[item.nCateTag].length>3" @click="openCloseYs(item)">
                            <img src="@/assets/images/processv2/open-close.png" alt="" :style="{'transform':item.bCateOpen?'rotate(0deg)':'rotate(180deg)'}">
                            <span>{{item.bCateOpen?'收起':'展开显示更多'}}</span>
                        </div>
                    </div>
                </div>
                <div class="report_tips" v-if="objReport.fin_status == 1">
                    <div class="tip-red">监理特别提醒：</div>
                    <div class="tips_text" v-html="objReport.head_tips"></div>
                </div>
                <div class="doubt" v-if="objReport.fin_status==1" @click="objReport.project_manager.length ? setQrcode(objReport.project_manager[0]) : ''">
                     <span>
                        有疑问
                    </span>
                </div>
            </div>
<!--            <div class="bottom_btn">-->
<!--                <div @click="submit">验收</div>-->
<!--            </div>-->
            <qrcode :nPopup.sync="bPopup" :nEwmImg="nEwmImg" :nTitle="stausName"></qrcode>
            <!-- 预览图片 -->
            <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex" @change="imageChange" :images="arrStausImg"></van-image-preview>
        </div>
        <img @click="toHome" class="tohome-icon" :class="{'tohome-icon_share':isShowShare}" src="@/assets/images/processv2/tohome.png" alt="">
        <share v-if="isShowShare" :isFixed="true" ref="myShare" :track-action="objReport.title | setTrackTitle"></share>
        <div class="fixed_box" :class="{'fixed_box_share':isShowShare}" @click="toEva" v-if="($route.query.completed == 1 || objReport.is_completed==1) && objReport.fin_status == 1">
            <img src="~@/assets/images/user/housev2/mail_icon.png" alt="">
            <!-- <p>总裁<br/>直通车</p> -->
            <p>我要<br/>评价</p>
        </div>
    </div>
</template>

<script>
import qrcode from "../components/qrcode.vue";
import oDeliver from "@/js/deliver.js";
import share from '../components/share.vue';
import {getReportShare} from "@/js/member/mynews";
export default {
    name: 'detail',
    components: {
        qrcode,
        share
    },
    data() {
        return {
            isContractAuth:false,
            shareTimeLog:null,
            isShowShare: false,//是否显示分享
            nEwmImg: '',
            imgShow: false,
            bPopup: false,
            arrStausImg: [],
            stausName: '',
            lookImgIndex: 0,
            nBgCateIndex:0,
            nCate: 0,
            objReport: {
                responsible:[],
                fin_status: 0,
                head_tips: '',
                service_supervisor: [],
                service_person: [],
                project_uuid: ',',
                bPerson:false,
            },
            bShowContent:false,
        }
    },
    filters:{
        setTrackTitle(title){
            switch (title){
                case '空调隐蔽系统施工监理报告':
                    return 'share_project_air'
                    break;
                case '新风系统施工监理报告':
                    return 'share_project_wind'
                    break;
                case '采暖隐蔽系统施工监理报告':
                    return 'share_project_heat'
                    break;
                case '系统竣工调试监理报告':
                    break;
            }
        }
    },
    created() {
        this.$store.commit("loadSwitch", true);
        let _that = this;
        $init(()=>{
            if(this.$route.query.projectmgnid){
                this.$storage.setStorage('project_uuid',this.$route.query.projectmgnid)
            }
            if(this.$route.query.form=='wxwork'){
                this.$storage.setStorage('share_source', 'wxwork') //通知过来的
            }
            _that.$oInitData.memberInfo({
                h5_user_id: _that.$storage.getStorage("user_id"),
            }).then((res) => {
                this.isContractAuth=true
                // 交付详情
                _that.getMeberInfo();
            }).finally(f=>{
                if (this.$route.query.shareId>0) {
                    let shareData = {
                        url:window.location.href,
                        project_uuid:this.$route.query.projectmgnid || this.$route.query.project_uuid,
                        id: this.$route.query.shareId,
                    }
                    getReportShare(shareData).then(res=>{
                        shareData.log_id=res.data.data.result.log_id
                        this.shareTimeLog= setInterval(()=>{
                            getReportShare(shareData)
                        },2000)
                    })
                }
            })
        })
        let sampleroom = this.$route.query.sampleroom || 0;
        if (sampleroom == 2 || sampleroom == 3) {
            this.isShowShare = true;
            setTimeout(()=>{
                this.$refs.myShare.setShare();
            },200)
        }

    },
    beforeDestroy() {
        clearInterval(this.shareTimeLog)
        this.shareTimeLog=null
    },
    methods: {
        // 跳转评价
        toEva() {
            let queryData = this.$route.query
            this.$router.push(`/member/v2/evaluate/finish?sharePersonId=${queryData.sharePersonId || 0}&company_id=${this.objReport.company_id}&project_uuid=${this.objReport.project_uuid}&contract_id=${this.objReport.contract_id}}&sampleroom=${queryData.sampleroom}&accountid=${queryData.accountid}&systemuserid=${queryData.systemuserid}`);
        },
        toHome(){
            let objSam =this.$route.query;
            this.$router.push(`/member/v2/index/index?sharePersonId=${objSam.sharePersonId || ''}&sampleroom=${objSam.sampleroom || ''}&accountid=${objSam.accountid || ''}&contractid=${objSam.contractid || ''}&systemuserid=${objSam.systemuserid || ''}`)
        },
        openCloseYs(item){
            item.bCateOpen=!item.bCateOpen
        },
        // 交付详情
        getMeberInfo() {
            let _that = this;
            _that.$store.commit("loadSwitch", true);
            oDeliver.processInfoV2({
                rule_report_id: _that.$route.query.id,
                projectmgnid: _that.$route.query.projectmgnid,
                workorder_id:_that.$route.query.workorder_id,
                sampleroom: _that.$route.query.sampleroom || 0
            }).then(res => {
                _that.$store.commit("loadSwitch", false);
                let objReport = res.result;
                console.log(objReport,'详情')
                this.$storage.setStorage('nRuleReportId',objReport.rule_report_id || 0)
                if( res.result.process){
                    res.result.process.forEach((it,index) => {
                        if (it.tag_list.length) {
                            it.nCateTag = it.tag_list[0].tag_id;
                            it.nCateTagSwiper = 0;
                        }
                        if(it.acceptance_line.length&&it.acceptance_line[it.nCateTag].length>3){
                            it.bCateOpen = false;
                        }else {
                            it.bCateOpen = true;
                        }
                    })
                }
                _that.bShowContent = true;
                res.result.head_tips = res.result.head_tips.replace(/[\r\n]/g, "<br>");
                if(objReport.title == '采暖隐蔽系统施工监理报告' && objReport.fin_status == 1 && !objReport.service_supervisor.length){
                    objReport.responsible = objReport.project_manager;
                    if((objReport.responsible.length&&objReport.responsible[0].job_number) == (objReport.service_person.length&&objReport.service_person[0].job_number)){
                        objReport.bPerson = true;
                    }else{
                        objReport.bPerson = false;
                    }
                }else{
                    objReport.responsible = objReport.service_supervisor;
                    objReport.bPerson = false;
                }
                console.log(objReport,'309')
                _that.objReport = objReport;
                document.title = objReport.title
            })
        },
        cliclTag(item, sumitem) {
            item.nCateTag = sumitem.tag_id;
        },
        swipetwo(e, item) {
            item.nCateTagSwiper = e;
        },
        //确认验收
        submit() {
            this.$router.push(`/user/house/v2/finish?company_id=${this.objReport.company_id}&contract_id=${this.objReport.contract_id}&project_uuid=${this.objReport.project_uuid}`)
        },
        setQrcode(item) {
            this.bPopup = true;
            this.stausName = item.name;
            this.nEwmImg = item.qr_code;
        },
        getShow(e,num,index) {
            this.nBgCateIndex = index;
            this.lookImgIndex = num;
            this.imgShow = true;
            this.arrStausImg = e;
        },
        imageChange(e){
            this.$refs['vanSwiper'+this.nBgCateIndex][0].swipeTo(e);
            this.nCateTagSwiper = e;
        }
    }
}
</script>

<style lang='scss' scoped>
.fixed_box {
    position: fixed;
    right: 0;
    z-index: 9;
    bottom: calc(40px + env(safe-area-inset-bottom));
    display: flex;
    justify-content: center;
    align-items: center;
    width: 194px;
    height: 108px;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 200px 0px 0px 200px;

    img {
        width: 72px;
        height: 72px;
        display: block;
        margin-right: 16px;
    }

    p {
        font-size: 22px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: $greenText;
        line-height: 26px;
    }
}
.fixed_box_share{
    bottom: calc(130px + env(safe-area-inset-bottom));
}
.tohome-icon{
    position: fixed;
    bottom: calc(150px + env(safe-area-inset-bottom));
    right: 50px;
    width: 100px;
    height: 100px;
    z-index: 99;
}
.tohome-icon_share{
    bottom: calc(250px + env(safe-area-inset-bottom));
}
.content {
    width: 100%;
    min-height: 100vh;
    padding: 330px 0 0;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F9F9F9;


    .content_bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 500px;
        z-index: 0;
        background: #7AA894;
    }

    .report_tips {
        width: 686px;
        background: #FFFFFF;
        box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.0800);
        border-radius: 16px;
        backdrop-filter: blur(0px);
        //margin-top: -102px;
        margin-bottom: 48px;
        // position: absolute;
        // top: 64px;
        padding: 48px 32px 48px 48px;
        box-sizing: border-box;
        z-index: 2;
        position: relative;
        .tip-red{
            color: red;
            font-size: 26px;
        }



        .tips_text {
            margin-top: 48px;
            font-size: 26px;
            font-weight: 400;
            color: #666666;
            line-height: 48px;
            text-align: justify;
        }
    }
    .report_tips_fin{
        margin-top: -190px;
        margin-bottom: 30px;
    }

    .report_warp {
        width: 100%;
        background: #F9F9F9;
        border-radius: 24px 24px 0 0;
        padding: 0px 32px 0;
        box-sizing: border-box;
        position: relative;
        z-index: 1;

        .report_item {
            width: 100%;
            height: 72px;
            height: auto;
            background: #EFF1F0;
            border-radius: 24px;
            overflow: hidden;
            transition: all 0.3s;
            margin-bottom: 32px;
            padding-top: 40px;

            .report_item_title {
                width: 100%;
                //height: 72px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px 0 32px;
                box-sizing: border-box;

                .span.title {
                    font-size: 24px;
                    font-weight: 700;
                    color: #355D4B;
                    line-height: 36px;
                }
                .span_title{
                    font-size: 30px;
                    color: #355D4B;
                    font-weight: bold;
                }

                .span_test {
                    font-size: 22px;
                    font-weight: 500;
                    color: #76A48F;
                    line-height: 34px;
                    display: flex;
                    align-items: center;

                    i {
                        display: inline-block;
                        width: 40px;
                        height: 40px;
                        background: url('~@/assets/images/member/process/top_icon.png') no-repeat center/100% 100%;
                        transform: rotate(-90deg);
                        margin-left: 20px;
                        transition: all 0.3s;
                    }

                    .open_test {
                        transform: rotate(90deg);
                    }
                }
            }

            .report_item_warp {
                padding: 0 24px 48px;
                box-sizing: border-box;
                position: relative;

                .line {
                    width: 100%;
                    height: 2px;
                    margin-top: 48px;
                    background: #D1DAD6;
                }

                .report_item_warp_text {
                    font-size: 26px;
                    font-weight: 400;
                    color: #666666;
                    display: flex;
                    align-items: center;
                    height: 118px;
                    position: relative;

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        display: inline-block;
                        width: 100%;
                        height: 2px;
                        background: #D1DAD6;
                    }
                }
            }

            .item_nav_center {
                justify-content: center;
            }

            .report_item_nav {
                display: flex;
                align-items: center;
                width: 100%;
                height: 118px;
                overflow: scroll;

                &::-webkit-scrollbar {
                    width: 0;
                    display: none;
                    background: transparent;
                }

                .nav_item {
                    flex-shrink: 0;
                    padding: 16px 28px;
                    box-sizing: border-box;
                    font-size: 24px;
                    font-weight: bold;
                    color: #355D4B;
                    line-height: 36px;
                    border-radius: 50px;
                    border: 1px solid #355D4B;
                    margin-right: 20px;
                }

                .atv_nav_item {
                    background: #355D4B;
                    color: #fff;
                }
            }

            .swiper_img {
                width: 100%;
                height: 360px;
                background: #D8D8D8;
                border-radius: 16px;
                overflow: hidden;
                position: relative;

                .swipe_img_url {
                    width: 100%;
                    height: 360px;

                    // position: relative;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .img_tips {
                        width: 100%;
                        height: 72px;
                        background: linear-gradient(266deg, rgba(0, 0, 0, 0) 0%, #5FA0D1 100%);
                        display: flex;
                        align-items: center;
                        position: absolute;
                        top: 0;
                        font-size: 26px;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 40px;
                        padding-left: 32px;
                        box-sizing: border-box;
                    }
                }

                .img_tips {
                    width: 100%;
                    height: 72px;
                    background: linear-gradient(266deg, rgba(0, 0, 0, 0) 0%, #5FA0D1 100%);
                    display: flex;
                    align-items: center;
                    position: absolute;
                    top: 0;
                    font-size: 26px;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 40px;
                    padding-left: 32px;
                    box-sizing: border-box;
                }

                .swiper_point {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: 16px;
                    left: 0;

                    div {
                        width: 16px;
                        height: 16px;
                        background: #7A8680;
                        margin-right: 16px;
                        border-radius: 50%;
                    }

                    div.color_point {
                        background: #355D4B;
                    }
                }
            }

            .swiper_list_sm {
                width: 100%;
                padding: 0 32px;
                box-sizing: border-box;
                margin-top: 32px;

                .swiper_list_scroll {
                    width: 100%;
                    overflow: scroll;
                    display: flex;
                    align-items: center;

                    &::-webkit-scrollbar {
                        display: none;
                        width: 0px;
                        background: transparent;
                    }
                }

                .swiper_list_item {
                    width: 96px;
                    height: 96px;
                    margin-right: 20px;
                    flex-shrink: 0;
                    border-radius: 10px;
                    overflow: hidden;

                    &:last-child {
                        margin-right: 0;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .swiper_list_item.click_item {
                    border: 6px solid #355D4B;
                }
            }

            .tabble {
                width: 100%;
                margin-top: 48px;


                .tabble_h {
                    display: flex;
                    justify-content: space-between;
                    font-size: 20px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 30px;
                    margin-bottom: 16px;

                    .tabble_h_one {
                        width: 64%;
                    }

                    .tabble_h_two {
                        width: 18%;
                        text-align: center;
                    }

                    .tabble_h_three {
                        width: 18%;
                        text-align: center;
                    }
                }

                .tabble_d {
                    margin-top: 48px;
                    .tabble_display{
                        display: flex;
                        justify-content: space-between;
                        font-size: 26px;
                        font-weight: 400;
                        color: #999999;
                        line-height: 40px;
                    }
                    .help_tips{
                        color: red;
                        font-size: 20px;
                    }
                    .tabble_d_one {
                        width: 64%;
                        display: flex;

                        span {
                            flex: 1;
                        }

                        &::before {
                            content: '';
                            display: inline-block;
                            width: 24px;
                            margin-top: 8px;
                            margin-right: 8px;
                            height: 24px;
                            background: #D1D7D4;
                            border-radius: 50%;

                        }
                    }
                     .tabble_d_one_active{
                        &::before {
                            content: '';
                            display: inline-block;
                            width: 24px;
                            margin-top: 8px;
                            margin-right: 8px;
                            height: 24px;
                            background: url('~@/assets/images/member/process/dui.png') no-repeat center/100% 100%;
                        }

                    }

                    .tabble_d_two {
                        width: 18%;
                        text-align: center;
                    }

                    .tabble_d_three {
                        width: 18%;
                        text-align: center;
                        color: #355D4B;
                    }
                }
            }
            .open_close{
                text-align: center;
                margin-top: 50px;
                color: #999999;
                font-size: 26px;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    margin-left: 10px;
                    width: 48px;
                    height: 48px;
                }
            }
        }

        .people {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            background: #EFF1F0;
            border-radius: 24px;
            margin-top: -190px;
            margin-bottom: 20px;
            position: relative;
            .fin_status {
                position: absolute;
                top: -70px;
                right: 100px;
                width: 155px;
                height: 144px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .fin_status-null{
                top: -120px;
                right: 10px;
            }

            .people_one {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                height: 194px;
                border-bottom: 2px solid #D1DAD6;

                .people_one_left {
                    display: flex;
                    align-items: center;

                    .header_img {
                        width: 132px;
                        height: 132px;
                        overflow: hidden;
                        border-radius: 50%;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .header_info {
                        font-size: 20px;
                        font-weight: 400;
                        color: #999999;
                        line-height: 30px;
                        margin-left: 32px;
                        .info_name_dai{
                            color: var(--color);
                            font-size: 28px;
                            line-height: 32px;
                            font-weight: 500;
                        }
                        .info_name {
                            font-size: 28px;
                            font-weight: 500;
                            color: #3D3C4F;
                            line-height: 42px;
                        }

                        .work_card {
                            font-size: 20px;
                            font-weight: 400;
                            color: #999999;
                            line-height: 30px;
                        }
                    }
                }

                .people_one_right {
                    width: 64px;
                    height: 64px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .people_two {
                width: 100%;
                //height: 194px;
                padding-top: 25px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;

                .people_warp_item {
                    width: 50%;
                    margin-bottom: 25px;

                    .people_one_left {
                        display: flex;
                        align-items: center;

                        .header_img {
                            width: 96px;
                            height: 96px;
                            overflow: hidden;
                            border-radius: 50%;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .header_info {
                            font-size: 20px;
                            font-weight: 400;
                            color: #999999;
                            line-height: 30px;
                            margin-left: 32px;

                            .info_name_dai{
                                color: var(--color);
                                font-size: 32px;
                                line-height: 36px;
                                font-weight: 500;
                            }
                            .info_name {
                                font-size: 28px;
                                font-weight: 500;
                                color: #3D3C4F;
                                line-height: 42px;
                            }

                            .work_card {
                                font-size: 20px;
                                font-weight: 400;
                                color: #999999;
                                line-height: 30px;
                            }
                        }
                    }
                }
            }
        }
        .people-fin{
            margin-top: 0px;
        }
        .doubt {
            padding: 64px 0;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;

             &::before {
                 content: '?';
                 width: 32px;
                 height: 32px;
                 border: 1px solid #B9B9B9;
                 display: flex;
                 align-items: center;
                 justify-content: center;
                 color: #B9B9B9;
                 border-radius: 50%;
                 margin-right: 8px;
             }

            span {
                font-size: 28px;
                line-height: 34px;
                font-weight: 400;
                color: #999999;
                border-bottom: 2px solid #B9B9B9;
                position: relative;

                a {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    margin: auto;
                    opacity: 0;
                    z-index: 2;
                }
            }
        }
    }

    .bottom_btn {
        background: #fff;
        width: 100%;
        padding: 20px 32px;
        box-sizing: border-box;
        box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.0800);
        border-radius: 24px 24px 0px 0px;
        backdrop-filter: blur(0px);

        div {
            width: 100%;
            height: 72px;
            background: #355D4B;
            border-radius: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 36px;
        }
    }
}
</style>
